import type { ReceivableUploadRowStatus } from "services/api/offPlatformReceivables";

interface ReceivableUploadCsvRow {
  rowNumber: number;
  invoiceNumber: string;
  loadNumber: string;
  paymentNumber: string;
  status: ReceivableUploadRowStatus;
  detail: string;
}

const UPLOAD_RESULTS_CSV_HEADER =
  "row_number,invoice_number,load_number,payment_number,status,detail";

const CSV_FORMULA_INJECTION_PATTERN = /^[-=+@\t\r]/;
const CSV_QUOTE_PATTERN = /[",\n\r]/;

export const escapeCsvCell = (value: string) => {
  let escaped = value;
  if (CSV_FORMULA_INJECTION_PATTERN.test(escaped)) {
    escaped = `'${escaped}`;
  }
  if (CSV_QUOTE_PATTERN.test(escaped)) {
    return `"${escaped.replace(/"/g, '""')}"`;
  }
  return escaped;
};

export const buildUploadResultsCsv = (rows: ReceivableUploadCsvRow[]) => {
  const lines = rows.map((row) =>
    [row.rowNumber, row.invoiceNumber, row.loadNumber, row.paymentNumber, row.status, row.detail]
      .map((value) => escapeCsvCell(String(value)))
      .join(",")
  );
  return [UPLOAD_RESULTS_CSV_HEADER, ...lines].join("\n");
};
